import React, { useState, useEffect } from 'react';
//import { graphql, withPrefix } from 'gatsby';

const SearchComponent = (props) => {
    const { allWpPost } = props
    const [searchText, setSearchText] = useState("")
    const handleChangeSearchBlog = (e) => {
        console.log('handleChangeSearchBlog heree', e.target.value)
        setSearchText(e.target.value)
      }
    
      const handleSubmitSearchBlog = (event) => {
        console.log('handleSubmitSearchBlog hereee');
        event.preventDefault()
    
      }

    return(
        <>
        <form role="search" className="search-form">
        <label htmlFor="search-form-1">

        <input
            type="search"
            id="search-form-1"
            onChange={handleChangeSearchBlog}
            className="search-field"
            placeholder="Search …"
            defaultValue={searchText}
            name="s"
        />
        </label>
        <input type="button" onClick={handleSubmitSearchBlog} className="search-submit" value="Search" />
    </form>
        </>
    )
}

export default SearchComponent